/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ head)
});

;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "core-js/modules/es.symbol.js"
const es_symbol_js_namespaceObject = require("core-js/modules/es.symbol.js");
;// external "core-js/modules/es.symbol.description.js"
const es_symbol_description_js_namespaceObject = require("core-js/modules/es.symbol.description.js");
;// external "core-js/modules/es.error.to-string.js"
const es_error_to_string_js_namespaceObject = require("core-js/modules/es.error.to-string.js");
;// external "core-js/modules/es.date.to-string.js"
const es_date_to_string_js_namespaceObject = require("core-js/modules/es.date.to-string.js");
;// external "core-js/modules/es.object.to-string.js"
const es_object_to_string_js_namespaceObject = require("core-js/modules/es.object.to-string.js");
;// external "core-js/modules/es.regexp.to-string.js"
const es_regexp_to_string_js_namespaceObject = require("core-js/modules/es.regexp.to-string.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
;// external "@babel/runtime/helpers/typeof"
const typeof_namespaceObject = require("@babel/runtime/helpers/typeof");
;// external "core-js/modules/es.array.concat.js"
const es_array_concat_js_namespaceObject = require("core-js/modules/es.array.concat.js");
;// external "core-js/modules/es.array.for-each.js"
const es_array_for_each_js_namespaceObject = require("core-js/modules/es.array.for-each.js");
;// external "core-js/modules/es.array.includes.js"
const es_array_includes_js_namespaceObject = require("core-js/modules/es.array.includes.js");
;// external "core-js/modules/es.array.iterator.js"
const es_array_iterator_js_namespaceObject = require("core-js/modules/es.array.iterator.js");
;// external "core-js/modules/es.array.some.js"
const es_array_some_js_namespaceObject = require("core-js/modules/es.array.some.js");
;// external "core-js/modules/es.date.to-iso-string.js"
const es_date_to_iso_string_js_namespaceObject = require("core-js/modules/es.date.to-iso-string.js");
;// external "core-js/modules/es.function.name.js"
const es_function_name_js_namespaceObject = require("core-js/modules/es.function.name.js");
;// external "core-js/modules/es.object.entries.js"
const es_object_entries_js_namespaceObject = require("core-js/modules/es.object.entries.js");
;// external "core-js/modules/es.object.keys.js"
const es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
;// external "core-js/modules/es.object.values.js"
const es_object_values_js_namespaceObject = require("core-js/modules/es.object.values.js");
;// external "core-js/modules/es.regexp.exec.js"
const es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// external "core-js/modules/es.string.iterator.js"
const es_string_iterator_js_namespaceObject = require("core-js/modules/es.string.iterator.js");
;// external "core-js/modules/es.string.replace.js"
const es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// external "core-js/modules/es.string.replace-all.js"
const es_string_replace_all_js_namespaceObject = require("core-js/modules/es.string.replace-all.js");
;// external "core-js/modules/es.string.starts-with.js"
const es_string_starts_with_js_namespaceObject = require("core-js/modules/es.string.starts-with.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "core-js/modules/web.dom-collections.for-each.js"
const web_dom_collections_for_each_js_namespaceObject = require("core-js/modules/web.dom-collections.for-each.js");
;// external "core-js/modules/web.dom-collections.iterator.js"
const web_dom_collections_iterator_js_namespaceObject = require("core-js/modules/web.dom-collections.iterator.js");
;// external "core-js/modules/web.url.js"
const web_url_js_namespaceObject = require("core-js/modules/web.url.js");
;// external "core-js/modules/web.url.can-parse.js"
const web_url_can_parse_js_namespaceObject = require("core-js/modules/web.url.can-parse.js");
;// external "core-js/modules/web.url.to-json.js"
const web_url_to_json_js_namespaceObject = require("core-js/modules/web.url.to-json.js");
;// external "core-js/modules/web.url-search-params.js"
const web_url_search_params_js_namespaceObject = require("core-js/modules/web.url-search-params.js");
;// external "core-js/modules/web.url-search-params.delete.js"
const web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// external "core-js/modules/web.url-search-params.has.js"
const web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// external "core-js/modules/web.url-search-params.size.js"
const web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// external "core-js/modules/es.array.join.js"
const es_array_join_js_namespaceObject = require("core-js/modules/es.array.join.js");
;// external "core-js/modules/es.array.map.js"
const es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// ./utils/src/stringifySrcset.js





var stringifySrcset_stringifySrcset = function stringifySrcset(imagePaths) {
  var resolutions = imagePaths ? Object.keys(imagePaths) : [];
  return resolutions.map(function (resolution) {
    return "".concat(imagePaths[resolution], " ").concat(resolution, "w");
  }).join(',');
};
;// ./utils/src/rebranding-images.js




var _excluded = (/* unused pure expression or super */ null && (["imagePath", "imagePaths", "src"]));





























var REBRAND_ASSETS_STORAGE = 'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/';
var REBRAND_ALLOWED_DOMAINS = ['https://http2.mlstatic.com/frontend-assets/growth-sellers-landings/', 'https://http2.mlstatic.com/resources/frontend/gsl-assets/', 'https://http2.mlstatic.com/storage/mgrowth-cc-blue-hero/', REBRAND_ASSETS_STORAGE];
var REBRAND_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg', 'webp'];
var REBRAND_SUFFIX = '--rebrand-mp';
var REBRAND_IMAGE_EXTENSION = 'webp';
var isValidRebrandDomain = function isValidRebrandDomain(url) {
  return REBRAND_ALLOWED_DOMAINS.some(function (domain) {
    return url === null || url === void 0 ? void 0 : url.startsWith(domain);
  });
};
var clearNameFile = function clearNameFile(name) {
  return {
    cleanName: name === null || name === void 0 ? void 0 : name.split('.').shift()
  };
};
var getNameFromUrl = function getNameFromUrl(url) {
  if (!URL.canParse(url)) {
    return null;
  }
  var urlObject = new URL(url);
  return {
    path: urlObject.pathname,
    name: clearNameFile(urlObject.pathname.split('/').pop()).cleanName
  };
};
var rewriteURL = function rewriteURL(url) {
  var _getNameFromUrl;
  if (!(url !== null && url !== void 0 && url.length) || !URL.canParse(url)) {
    return '';
  }
  var extension = url.split('.').pop();
  if (!REBRAND_ALLOWED_EXTENSIONS.includes(extension) || !isValidRebrandDomain(url)) {
    return url;
  }
  var dateParam = "".concat(new Date().toISOString().split('T')[0].replaceAll('-', ''));
  var filename = (_getNameFromUrl = getNameFromUrl(url)) === null || _getNameFromUrl === void 0 ? void 0 : _getNameFromUrl.name;
  var rebrandFilename = "".concat(filename).concat(REBRAND_SUFFIX, ".").concat(REBRAND_IMAGE_EXTENSION, "?d=").concat(dateParam);
  return "".concat(REBRAND_ASSETS_STORAGE).concat(rebrandFilename);
};
var rewriteImagePaths = function rewriteImagePaths(imagePaths) {
  if (!imagePaths || _typeof(imagePaths) !== 'object' || Object.keys(imagePaths).length < 1) {
    return {};
  }
  var clone = {};
  Object.entries(imagePaths).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    clone["".concat(key)] = rewriteURL(value);
  });
  return clone;
};
var getImageProperties = function getImageProperties(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!image || _typeof(image) !== 'object' || Object.keys(image) < 1) {
    return null;
  }
  var _options$setDefaultSr = options.setDefaultSrc,
    setDefaultSrc = _options$setDefaultSr === void 0 ? false : _options$setDefaultSr,
    _options$setSrcSetStr = options.setSrcSetString,
    setSrcSetString = _options$setSrcSetStr === void 0 ? false : _options$setSrcSetStr,
    _options$setImagePath = options.setImagePathsObject,
    setImagePathsObject = _options$setImagePath === void 0 ? false : _options$setImagePath,
    _options$rewriteURLs = options.rewriteURLs,
    rewriteURLs = _options$rewriteURLs === void 0 ? false : _options$rewriteURLs;
  var imagePath = image.imagePath,
    imagePaths = image.imagePaths,
    initialSrc = image.src,
    otherProps = _objectWithoutProperties(image, _excluded);
  var clone = _objectSpread({}, otherProps);
  var paths = imagePaths !== null && imagePaths !== void 0 ? imagePaths : imagePath;
  var src = initialSrc;
  if (rewriteURLs) {
    paths = _objectSpread({}, rewriteImagePaths(paths));
    if (!src && paths) {
      var imagePathsValues = Object.values(paths);
      src = imagePathsValues.length > 0 ? imagePathsValues[0] : '';
    }
    src = rewriteURL(src);
  }
  if (setDefaultSrc) {
    var defaultPath = null;
    try {
      var _Object$values;
      // defaults to second element (768px resource)
      defaultPath = ((_Object$values = Object.values(paths)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 1 ? Object.values(paths)[1] : '';
    } catch (err) {
      defaultPath = '';
    }
    clone.src = src !== null && src !== void 0 ? src : defaultPath;
  } else {
    clone.src = src;
  }
  if (setSrcSetString) {
    clone.srcset = stringifySrcset(paths);
  }
  if (setImagePathsObject) {
    clone.imagePaths = _objectSpread({}, paths);
  }
  return clone;
};
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/sections/head/src/Head.js

var _meta, _meta2;






/* istanbul ignore file */
/**
 * Head dependencies
 */





/**
 * Head
 */

var Head = function Head(_ref) {
  var title = _ref.title,
    description = _ref.description,
    keywords = _ref.keywords,
    noIndex = _ref.noIndex,
    linkCanonical = _ref.linkCanonical,
    googleSiteVerification = _ref.googleSiteVerification,
    _ref$openGraph = _ref.openGraph,
    ogImage = _ref$openGraph.ogImage,
    ogWidth = _ref$openGraph.ogWidth,
    ogHeight = _ref$openGraph.ogHeight,
    ogUrl = _ref$openGraph.ogUrl,
    ogType = _ref$openGraph.ogType,
    ogLocale = _ref$openGraph.ogLocale,
    ogSiteName = _ref$openGraph.ogSiteName,
    ogAudio = _ref$openGraph.ogAudio,
    ogVideo = _ref$openGraph.ogVideo;
  var _ref2 = (0,framework_namespaceObject.useCalmContext)() || {},
    _ref2$isRebrand = _ref2.isRebrand,
    isRebrand = _ref2$isRebrand === void 0 ? false : _ref2$isRebrand,
    _ref2$keepImageURLs = _ref2.keepImageURLs,
    keepImageURLs = _ref2$keepImageURLs === void 0 ? false : _ref2$keepImageURLs;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/jsx_default()("title", {}, void 0, title), /*#__PURE__*/jsx_default()("meta", {
      name: "description",
      content: description
    }), keywords !== null && keywords !== void 0 && keywords.length ? /*#__PURE__*/jsx_default()("meta", {
      name: "keywords",
      content: keywords.toString()
    }) : null, !noIndex && /*#__PURE__*/jsx_default()("link", {
      rel: "canonical",
      href: linkCanonical
    }), noIndex && (_meta || (_meta = _meta2 || (_meta2 = /*#__PURE__*/jsx_default()("meta", {
      name: "robots",
      content: "noindex, nofollow"
    })))), googleSiteVerification && /*#__PURE__*/jsx_default()("meta", {
      name: "google-site-verification",
      content: googleSiteVerification
    }), /*#__PURE__*/jsx_default()("meta", {
      property: "og:title",
      content: title
    }), /*#__PURE__*/jsx_default()("meta", {
      property: "og:description",
      content: description
    }), Boolean(ogImage) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:image",
      content: isRebrand && !keepImageURLs ? rewriteURL(ogImage) : ogImage
    }), Boolean(ogWidth) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:image:width",
      content: ogWidth
    }), Boolean(ogHeight) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:image:height",
      content: ogHeight
    }), Boolean(ogUrl) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:url",
      content: ogUrl
    }), Boolean(ogType) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:type",
      content: ogType
    }), Boolean(ogLocale) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:locale",
      content: ogLocale
    }), Boolean(ogSiteName) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:site_name",
      content: ogSiteName
    }), Boolean(ogAudio) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:audio",
      content: ogAudio
    }), Boolean(ogVideo) && /*#__PURE__*/jsx_default()("meta", {
      property: "og:video",
      content: ogVideo
    })]
  });
};

/**
 * PropTypes
 */

/**
 * Default Props
 */

Head.defaultProps = {
  keywords: '',
  linkCanonical: '',
  googleSiteVerification: '',
  openGraph: {}
};

/**
 * Export Head
 */
/* harmony default export */ const src_Head = (Head);
;// ./packages/head/src/Head.js

/* harmony default export */ const head_src_Head = (src_Head);
;// ./packages/head/index.js
/**
 * Export Component
 */

/* harmony default export */ const head = (head_src_Head);
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map